const { io } = require("socket.io-client") ;
let socket;
const store = require('./store');
let activeSite;
let heartbeatInterval;

function init(server, tokenFn) {

    socket = io(server, {
        auth: (cb) => cb(tokenFn()), 
        withCredentials: true,
        // Aggressive reconnection settings
        reconnection: true,
        reconnectionAttempts: Infinity,  // Keep trying forever
        reconnectionDelay: 1000,          // Start with 1 second delay
        reconnectionDelayMax: 5000,      // Max 5 seconds between attempts
        randomizationFactor: 0.5,        // Add randomization to avoid thundering herd
        timeout: 20000,                  // Increase connection timeout to 20 seconds
        autoConnect: false,              // We'll manually connect
        transports: ['websocket', 'polling'], // Try websocket first, fallback to polling
        // Additional settings for stability
        upgrade: true,                   // Allow upgrading from polling to websocket
        rememberUpgrade: true,          // Remember the transport upgrade
        closeOnBeforeunload: false,     // Don't close on page navigation
        // Path and query settings
        path: '/socket.io/',
        query: {},
    });

    addEventHandlers()

    socket.connect();


// // or if the `auth` attribute is a function
//     const socket = io({

//     });

    socket.on("disconnect", (reason) => {
        console.log(`[Socket.IO] Disconnected: ${reason}`);
        
        // Log more details about the disconnect
        const errorReasons = {
            'io server disconnect': 'Server forcefully disconnected the client',
            'io client disconnect': 'Client disconnected manually',
            'ping timeout': 'Server did not respond to ping in time',
            'transport close': 'Connection was closed (network issue)',
            'transport error': 'Connection encountered an error'
        };
        
        if (errorReasons[reason]) {
            console.log(`[Socket.IO] Reason details: ${errorReasons[reason]}`);
        }
        
        // Force reconnection on certain disconnect reasons
        if (reason === "io server disconnect" || reason === "transport close" || reason === "transport error") {
            console.log('[Socket.IO] Attempting immediate reconnection...');
            setTimeout(() => {
                if (!socket.connected) {
                    socket.connect();
                }
            }, 1000);
        }
    });
    
    socket.on("connect_error", (error) => {
        // Log different types of connection errors
        if (error.type === 'TransportError') {
            console.error('[Socket.IO] Transport error:', error.message);
        } else if (error.message.includes('xhr poll error')) {
            console.error('[Socket.IO] Polling error - WebSocket may be blocked');
        } else {
            console.error('[Socket.IO] Connection error:', error.message);
        }
        
        // Check if this is a CORS or auth issue
        if (error.message.includes('CORS') || error.message.includes('401')) {
            console.error('[Socket.IO] Authentication or CORS issue detected');
        }
    });
    
    socket.io.on("reconnect", (attempt) => {
        console.log(`[Socket.IO] ✓ Reconnected successfully after ${attempt} attempt(s)`);
        
        // Re-join site if we were in one
        if (activeSite) {
            console.log(`[Socket.IO] Re-joining site: ${activeSite}`);
            socket.emit('joinSite', activeSite);
        }
    });
    
    socket.io.on("reconnect_attempt", (attemptNumber) => {
        console.log(`[Socket.IO] Reconnection attempt #${attemptNumber}`);
    });
    
    socket.io.on("reconnect_error", (error) => {
        console.error('[Socket.IO] Reconnection error:', error.message);
    });
    
    socket.io.on("reconnect_failed", () => {
        console.error('[Socket.IO] Reconnection failed after all attempts');
        // This shouldn't happen with infinite attempts, but just in case
        setTimeout(() => {
            console.log('[Socket.IO] Manually retrying connection...');
            socket.connect();
        }, 5000);
    });
}

function addEventHandlers() {

    socket.removeAllListeners();
    socket.offAny();

    socket.on("connect", () => {
        console.log('Socket Connected successfully');
        if (activeSite) {
            console.log('Rejoining site:', activeSite);
            socket.emit('joinSite', activeSite);
        }
        
        // No longer using custom heartbeat - using socket.io's built-in ping/pong
        // startHeartbeat();
    });

    socket.on("changeEvent", (payload) => {
        store.default.dispatch('upsert', payload || true)
    })

    // socket.onAny((eventName, payload) => {
    //     // Check If Controller Event
    //     if (payload && typeof payload === 'object' && payload.updateEvent) {
    //         // Add To The Pool
    //         eventPool[eventName] = payload.payload
    //         setTimeout(() => {
    //             delete eventPool[eventName]
    //         }, 5000);
    //         // Do The Upsert
    //         store.default.dispatch('upsert', payload.payload || true)
    //         // Emit An Event For Success
    //         emitter.emit(eventName, {status: payload.status, payload: payload.payload})
    //     }
    // });
}

function switchSite(siteId) {
    activeSite = siteId;
    if (socket && activeSite)
        socket.emit('quitSite', activeSite)
    if (socket)
        socket.emit('joinSite', siteId)
}

function getConnectionStatus() {
    try {
        return socket && socket.connected
    } catch (e) {
        return false
    }
}

function forceReconnect() {
    if (socket) {
        console.log('Forcing socket reconnection...');
        socket.disconnect();
        setTimeout(() => {
            socket.connect();
        }, 100);
    }
}

function startHeartbeat() {
    stopHeartbeat(); // Clear any existing interval
    
    let missedPings = 0;
    
    heartbeatInterval = setInterval(() => {
        if (!socket.connected) {
            console.log('Heartbeat: Socket not connected, clearing interval');
            stopHeartbeat();
            return;
        }
        
        // Send ping with timeout
        const pingTimeout = setTimeout(() => {
            missedPings++;
            console.log(`Heartbeat: Missed ping response (${missedPings}/3)`);
            
            if (missedPings >= 3) {
                console.log('Heartbeat: Connection seems stale, forcing reconnection');
                forceReconnect();
                missedPings = 0;
            }
        }, 3000); // 3 second timeout for pong response
        
        socket.emit('ping', () => {
            // Pong received
            clearTimeout(pingTimeout);
            missedPings = 0; // Reset counter on successful pong
        });
    }, 10000); // Send ping every 10 seconds
}

function stopHeartbeat() {
    if (heartbeatInterval) {
        clearInterval(heartbeatInterval);
        heartbeatInterval = null;
    }
}

module.exports = {
    initSocket: init,
    switchSite,
    getConnectionStatus,
    getSocket: () => socket,
    forceReconnect
}